module.exports = __webpack_public_path__ + "img/seal.97aad03c.jpg";